/* From: https://stackoverflow.com/a/56859650 */
import type { MatcherFunction } from '@testing-library/react';

type Query = (f: MatcherFunction) => HTMLElement;
export const withMarkup =
  (query: Query) =>
  (text: string): HTMLElement =>
    query((_content, node) => {
      if (!node) return false;
      const hasText = (nestedNode: Element) => nestedNode.textContent === text;
      const childrenDontHaveText = Array.from(node.children).every((child) => !hasText(child));
      return hasText(node) && childrenDontHaveText;
    });
